import { useState } from 'react';
import { apiClient, ApiError } from '../lib/api';

interface ImportDialogProps {
  onClose: () => void;
  onImported: (id: string) => void;
}

export function ImportDialog({ onClose, onImported }: ImportDialogProps) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!url.trim()) {
      setError('Paste a GitHub URL.');
      return;
    }
    setBusy(true);
    try {
      const result = await apiClient.publish.fromGithub({ url: url.trim() });
      onImported(result.id);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Import failed');
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-lg border bg-canvas p-5 text-sm"
        style={{ boxShadow: '0 20px 60px rgba(0,0,0,.18)' }}
      >
        <h2 className="text-base font-semibold">Import from GitHub</h2>
        <p className="mt-1 text-[12px] text-text-subtle">
          Paste a public GitHub URL — raw file, blob URL, or gist page. We create a fresh
          skill in your library; existing skills are never overwritten.
        </p>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://gist.github.com/you/abc123"
          autoFocus
          className="mt-3 block w-full rounded border bg-surface px-2 py-1.5 font-mono text-[12px] outline-none focus:border-[var(--color-accent)]"
        />
        {error && (
          <p className="mt-2 rounded border bg-danger-soft p-2 text-[11px] text-[var(--color-danger)]">
            {error}
          </p>
        )}
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn">
            Cancel
          </button>
          <button type="submit" disabled={busy} className="btn btn-primary">
            {busy ? 'Importing…' : 'Import'}
          </button>
        </div>
      </form>
    </div>
  );
}
